import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import WorklogHoursSection from './WorklogHoursSection';
import AddedWorklogs from './AddedWorklogs';

function WorklogSection(props) {
  const {
    workItem,
    ticket,
    project,
    refetch,
    module,
    getItemsToInvoice,
    hideTaskWorkItem
  } = props;
  const flags = useFlags();

  return (
    <>
      <WorklogHoursSection
        workItem={workItem}
        ticket={ticket}
        project={project}
        module={module}
        refetch={refetch}
        showAlltimersList
        highlightRunningTimer
        hideWorkitem
        allowEmptyNotes={!!props?.allowEmptyNotes}
        editWorklogZIndex={500}
        hideTaskWorkItem={hideTaskWorkItem}
      />
      <AddedWorklogs
        workItem={workItem}
        ticket={ticket}
        project={project}
        module={module}
        refetch={refetch}
        mode={props?.mode}
        onViewModeClick={props?.onViewModeClick}
        getItemsToInvoice={getItemsToInvoice}
      />
    </>
  );
}

export default WorklogSection;
